import React from "react";

const Footer = () => {
  return (
    <>
     <div
        className="bg-cover bg-center h-auto px-6 md:px-[4.5rem] py-9 md:py-[3.56rem] mt-8 md:mt-16"
        style={{ backgroundImage: "url(/assets/WithNimoBg.svg)" }}
      >
        <div className="md:w-1/2">
          <h2 className="text-white font-[Figtree] text-[1.47131rem] md:text-[2.375rem] font-normal text-center md:text-left leading-[2.09088rem] md:leading-[3.375rem] tracking-[-0.095rem] mb-3 md:mb-4">
            <span className="font-bold">With nimo,</span> foreign spending
            becomes effortless
          </h2>
          <p className="text-white/75 font-[Figtree] text-[0.77438rem] text-center md:text-left md:text-[1.25rem] font-medium leading-[1.04544rem] md:leading-[1.6875rem] -tracking-[-0.05rem]">
           <span className="font-extrabold text-white">Seamlessly manage your money</span>{" "}whether you’re travelling, shopping online, or handling corporate expenses. Stay ahead, stay smart, and make every transaction count with <span className="font-extrabold text-white">nimo.</span>
          </p>
        </div>
      </div>
      <div className="md:px-[4.5rem] px-6 pb-12 md:flex items-center">
        <div className="md:w-[30%]">
          <img
            src="/assets/FooterLogo.png"
            alt="footerLogo"
            className="md:w-[10rem] md:h-[10rem] w-[6rem] h-[6rem]"
          />
          <div className="flex gap-4">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="39"
                height="39"
                viewBox="0 0 39 39"
                fill="none"
              >
                <circle
                  cx="19.5"
                  cy="19.5"
                  r="19.5"
                  fill="#D9D9D9"
                  fill-opacity="0.31"
                />
                <path
                  d="M23.5911 15.9132C23.5911 15.6866 23.6811 15.4692 23.8414 15.3089C24.0017 15.1486 24.219 15.0586 24.4457 15.0586C24.6724 15.0586 24.8897 15.1486 25.05 15.3089C25.2103 15.4692 25.3003 15.6866 25.3003 15.9132C25.3003 16.1399 25.2103 16.3573 25.05 16.5175C24.8897 16.6778 24.6724 16.7679 24.4457 16.7679C24.219 16.7679 24.0017 16.6778 23.8414 16.5175C23.6811 16.3573 23.5911 16.1399 23.5911 15.9132Z"
                  fill="#505050"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.1726 16.127C19.0959 16.127 18.0633 16.5547 17.302 17.316C16.5407 18.0773 16.113 19.1098 16.113 20.1865C16.113 21.2631 16.5407 22.2957 17.302 23.057C18.0633 23.8183 19.0959 24.246 20.1726 24.246C21.2492 24.246 22.2818 23.8183 23.0431 23.057C23.8044 22.2957 24.2321 21.2631 24.2321 20.1865C24.2321 19.1098 23.8044 18.0773 23.0431 17.316C22.2818 16.5547 21.2492 16.127 20.1726 16.127ZM17.395 20.1865C17.395 19.4498 17.6876 18.7433 18.2085 18.2224C18.7294 17.7015 19.4359 17.4089 20.1726 17.4089C20.9092 17.4089 21.6157 17.7015 22.1366 18.2224C22.6575 18.7433 22.9501 19.4498 22.9501 20.1865C22.9501 20.9231 22.6575 21.6296 22.1366 22.1505C21.6157 22.6714 20.9092 22.964 20.1726 22.964C19.4359 22.964 18.7294 22.6714 18.2085 22.1505C17.6876 21.6296 17.395 20.9231 17.395 20.1865Z"
                  fill="#505050"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M24.6662 12.3519C21.6795 12.0207 18.6654 12.0207 15.6788 12.3519C13.9593 12.5442 12.5705 13.8988 12.3688 15.6269C12.0151 18.6563 12.0151 21.7165 12.3688 24.7459C12.5705 26.4739 13.9584 27.8285 15.6788 28.0208C18.6655 28.3514 21.6795 28.3514 24.6662 28.0208C26.3857 27.8285 27.7745 26.4739 27.9762 24.7459C28.3299 21.7165 28.3299 18.6563 27.9762 15.6269C27.7745 13.8988 26.3865 12.5442 24.6662 12.3519ZM15.8207 13.6253C18.713 13.3046 21.6319 13.3046 24.5243 13.6253C25.6609 13.7535 26.5711 14.6501 26.7036 15.7765C27.0464 18.7064 27.0464 21.6663 26.7036 24.5963C26.6351 25.1476 26.3827 25.6596 25.9873 26.0498C25.5918 26.44 25.0764 26.6854 24.5243 26.7466C21.6319 27.0673 18.713 27.0673 15.8207 26.7466C15.2685 26.6854 14.7531 26.44 14.3577 26.0498C13.9622 25.6596 13.7099 25.1476 13.6414 24.5963C13.2985 21.6663 13.2985 18.7064 13.6414 15.7765C13.7099 15.2252 13.9622 14.7131 14.3577 14.3229C14.7531 13.9328 15.2685 13.6865 15.8207 13.6253Z"
                  fill="#505050"
                />
              </svg>
            </div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="39"
                height="39"
                viewBox="0 0 39 39"
                fill="none"
              >
                <circle
                  cx="19.5"
                  cy="19.5"
                  r="19.5"
                  fill="#D9D9D9"
                  fill-opacity="0.31"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M26.3431 12.2609C26.6075 12.4996 26.642 12.9237 26.4201 13.2082L21.863 19.0511L26.6877 26.3286C26.8074 26.5096 26.8788 26.7229 26.8936 26.9444C26.9084 27.1659 26.8663 27.3876 26.7718 27.585C26.6773 27.7825 26.5341 27.9482 26.358 28.064C26.1818 28.1798 25.9794 28.2411 25.773 28.2414H23.6675C23.6674 28.2414 23.6676 28.2414 23.6675 28.2414C23.4882 28.2415 23.3112 28.1954 23.1517 28.107C22.9924 28.0186 22.855 27.8906 22.751 27.7336M22.751 27.7336L19.2315 22.4247L14.8822 28.0012C14.6603 28.2857 14.2661 28.3228 14.0017 28.0841C13.7373 27.8454 13.7028 27.4213 13.9246 27.1368L18.4818 21.2938L13.6571 14.0163C13.5374 13.8354 13.4659 13.6221 13.4511 13.4005C13.4363 13.179 13.4785 12.9574 13.573 12.7599C13.6675 12.5624 13.8106 12.3968 13.9868 12.281C14.163 12.1652 14.3653 12.1038 14.5718 12.1035L16.6773 12.1035C16.6772 12.1035 16.6773 12.1035 16.6773 12.1035C16.8566 12.1035 17.0336 12.1496 17.193 12.238C17.3525 12.3264 17.49 12.4546 17.5941 12.6119L21.1133 17.9202L25.4626 12.3437C25.6845 12.0592 26.0787 12.0221 26.3431 12.2609M19.7804 20.9368L23.7315 26.8966H25.5289L20.5644 19.4082L16.6133 13.4484H14.8159L19.7804 20.9368ZM16.6777 13.4484C16.6777 13.4484 16.6778 13.4484 16.6777 13.4484V13.4484Z"
                  fill="#505050"
                />
              </svg>
            </div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="39"
                viewBox="0 0 40 39"
                fill="none"
              >
                <circle
                  cx="20.0869"
                  cy="19.5"
                  r="19.5"
                  fill="#D9D9D9"
                  fill-opacity="0.31"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M19.7483 13.3676C20.4444 12.5582 21.3885 12.1035 22.3729 12.1035H24.3094C24.5768 12.1035 24.7936 12.3556 24.7936 12.6665V15.6689C24.7936 15.9798 24.5768 16.2318 24.3094 16.2318H22.3729C22.3301 16.2318 22.289 16.2516 22.2588 16.2868C22.2285 16.322 22.2115 16.3697 22.2115 16.4195V18.1083H24.3094C24.4585 18.1083 24.5993 18.1882 24.691 18.3248C24.7828 18.4615 24.8153 18.6396 24.7791 18.8078L24.1336 21.8102C24.0797 22.0608 23.8861 22.2366 23.6639 22.2366H22.2115V27.6785C22.2115 27.9894 21.9947 28.2414 21.7274 28.2414H19.1453C18.8779 28.2414 18.6612 27.9894 18.6612 27.6785V22.2366H17.2087C16.9414 22.2366 16.7246 21.9846 16.7246 21.6737V18.6713C16.7246 18.3604 16.9414 18.1083 17.2087 18.1083H18.6612V16.4195C18.6612 15.2748 19.0522 14.177 19.7483 13.3676ZM22.3729 13.2294C21.6453 13.2294 20.9475 13.5655 20.433 14.1638C19.9185 14.762 19.6294 15.5734 19.6294 16.4195V18.6713C19.6294 18.9822 19.4127 19.2342 19.1453 19.2342H17.6929V21.1107H19.1453C19.4127 21.1107 19.6294 21.3628 19.6294 21.6737V27.1155H21.2432V21.6737C21.2432 21.3628 21.46 21.1107 21.7274 21.1107H23.2859L23.6894 19.2342H21.7274C21.46 19.2342 21.2432 18.9822 21.2432 18.6713V16.4195C21.2432 16.0711 21.3622 15.737 21.5741 15.4907C21.7859 15.2443 22.0733 15.1059 22.3729 15.1059H23.8253V13.2294H22.3729Z"
                  fill="#505050"
                />
              </svg>
            </div>
          </div>
          <div className="flex gap-4 md:my-[2.12rem] mt-6">
            <div>
              <img
                src="/assets/startup-india-logo.svg"
                alt="startup-india-logo"
              />
            </div>
            <div>
              <img src="/assets/Logo-ISO.svg" alt="ISO Logo" />
            </div>
            <div>
              <img
                src="/assets/VeriSign__Inc_Logo.svg"
                alt="VeriSign__Inc_Logo"
              />
            </div>
          </div>
          <div className="flex gap-[0.44rem]">
              <div>
                <img src="/assets/MakeInIndiaIcon.svg" alt="MakeInIndiaIcon" />
              </div>
              <div>
                <img
                  src="/assets/DigitalIndiaIcon.svg"
                  alt="DigitalIndiaIcon"
                />
              </div>
              <div>
                <img
                  src="/assets/CashLessIndiaIcon.svg"
                  alt="CashLessIndiaIcon"
                />
              </div>
            </div>
        </div>
        <div className="md:w-[70%] flex md:justify-between flex-wrap md:flex-nowrap mt-8 md:mt-8 md:gap-[7rem]  gap-y-8 md:gap-x-16 gap-x-28 font-[Figtree]">
          <div>
            <h3 className="text-black font-bold md:mb-[2.94rem] mb-4 md:text-[1.125rem] text-[0.75rem] text-left leading-5 font-[Figtree]">
              Company
            </h3>
            <ul className="space-y-2 text-left">
              <li>
                <a
                  href="#"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  Careers
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  Blogs
                </a>
              </li>
              <li>
                <a
                  href="/faq"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  FAQs
                </a>
              </li>
              <li>
                <a
                  href="/support"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
          {/* <!-- Services Column --> */}
          <div>
            <h3 className="text-black font-bold md:mb-[2.94rem] mb-4 md:text-[1.125rem] text-[0.75rem] text-left leading-5 font-[Figtree]">
              Services
            </h3>
            <ul className="space-y-2 text-left">
              <li>
                <a
                  href="/forex-cards"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  Forex Cards
                </a>
              </li>
              <li>
                <a
                  href="/exchange"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  Currency Exchange
                </a>
              </li>
              <li>
                <a
                  href="/nimo-remittance"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  Remittance
                </a>
              </li>
              <li>
                <a
                  href="/corporate-solutions"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  Corporate Solution
                </a>
              </li>
            </ul>
          </div>
          {/* <!-- Resources Column --> */}
          <div>
            <h3 className="text-black font-bold md:mb-[2.94rem] mb-4 md:text-[1.125rem] text-[0.75rem] text-left leading-5 font-[Figtree]">
              Resources
            </h3>
            <ul className="space-y-2 text-left">
              <li>
                <a
                  href="#"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  View Rates
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  Track Remittance
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  Offers & Rewards
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  Loyalty Program
                </a>
              </li>
            </ul>
          </div>
          {/* <!-- Policies Column --> */}
          <div>
            <h3 className="text-black font-bold md:mb-[2.94rem] mb-4 md:text-[1.125rem] text-[0.75rem] text-left leading-5 font-[Figtree]">
              Policies
            </h3>
            <ul className="space-y-2 text-left">
              <li>
                <a
                  href="#"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  Terms of Use
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  Grievance Redressal
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-black md:text-[0.9375rem] text-[0.625rem] mb-5 font-medium font-[Figtree] leading-5 tracking-[-0.0375rem]"
                >
                  Responsible Disclosure
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="bg-[#DC143C]">
        <h2 className="md:py-[1.44rem] py-[0.5rem] text-center text-white md:text-[0.75rem] text-[0.625rem] font-[Manrope] font-semibold tracking-[-0.015rem]">
          Copyright @nimo | All Rights Reserved
        </h2>
      </div>
    </>
  );
};

export default Footer;
